<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.name_rus"
        v-bind="fieldsDefinitions.name_rus" @error="(err) => setFieldError('name_rus', err)"/>
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.name_eng"
        v-bind="fieldsDefinitions.name_eng" @error="(err) => setFieldError('name_eng', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.code"
        v-bind="fieldsDefinitions.code" @error="(err) => setFieldError('code', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.skill_status_id"
        v-bind="fieldsDefinitions.skill_status_id" :items="statusesForSelect"
        @change="onStatusSearch" @error="(err) => setFieldError('skill_status_id', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'CreateSkill',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        code: {
          isValid: false,
          validationRules: {
            maxLength: 4,
          },
          error: '',
          required: true,
          type: "text",
          label: "Код",
          placeholder: "Введите код",
        },
        name_rus: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название (рус.)",
          placeholder: "Введите название",
        },
        name_eng: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название (англ.)",
          placeholder: "Введите название",
        },
        skill_status_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Статус",
          placeholder: "Начните ввод для поиска",
        },
      },
      fieldsValues: {
        code: '',
        name_rus: '',
        name_eng: '',
        skill_status_id: undefined,
      },
      statusesForSelect: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  methods: {
    ...mapActions('skills', ['createSkill', 'updateSkill']),
    async onStatusSearch(text) {
      [this.statusesForSelect] = await this.getAutocompleteData('/v1/skills/statuses/list', text);
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          await this.editSkill();
        } else {
          await this.addSkill();
        }
      }
    },
    async addSkill() {
      try {
        await this.createSkill(this.fieldsValues);
        this.$toasted.success('Компетенция добавлена');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editSkill() {
      try {
        await this.updateSkill(this.fieldsValues);
        this.$toasted.success('Изменения сохранены');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
  },
  created() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = this.$props.data;
      if (this.fieldsValues.status_id) {
        this.statusesForSelect = [{
          prop: this.fieldsValues.status_id,
          searchText: this.fieldsValues.status,
        }];
        this.fieldsValues.skill_status_id = this.fieldsValues.status_id;
      }
    }
  },
}
</script>

<style>

</style>